// src/components/Header.js
import React, { useEffect, useState } from 'react';
import { auth, firestore } from '../../Config/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import './styles.scss';

const Header = ({openTitleScreen,userName}) => {




  const handleLogout = async () => {
    try {
        openTitleScreen()
        setTimeout(async() => {
            await signOut(auth); 
        }, 2000);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        {/* <div className="welcome-text-container">
        {userName && <h1 className='welcome-text'>Welcome, {userName}</h1>}
        </div> */}
        <img
          className="header-image"
          src="https://mhreserve.com/wp-content/uploads/reserve/assets/logo.png"
          alt="Header"
        />
        <div className="logout-button-container">
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
